import { Typography, Paper, Stack } from '@newulife/common';

/**
 * @props title (optional) Renders a title before a shadow card
 */

function ShadowCard(props) {
  const { children, title, ...rest } = props;
  return (
    <Stack data-testid={`${title?.replace(/\W/g, '')}-section`} width="100%" pb={4} {...rest}>
      {title && (
        <Typography
          variant="h3"
          textAlign="center"
          mb={2}
          sx={{
            textTransform: 'capitalize',
          }}
        >
          {title}
        </Typography>
      )}
      <Paper
        elevation={0}
        sx={{
          width: '100%',
          p: 0,
          borderRadius: '17px',
          marginBottom: '20px',
        }}
      >
        {children}
      </Paper>
    </Stack>
  );
}

export default ShadowCard;
